// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-link-list {
  display: flex;
  gap: var(--icon-link-list-gap);
  width: min-content;
}

.icon-link-list__item {
  height: var(--icon-link-size);
  width: var(--icon-link-size);
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/iconLinkList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B","sourcesContent":[".icon-link-list {\r\n  display: flex;\r\n  gap: var(--icon-link-list-gap);\r\n  width: min-content;\r\n}\r\n\r\n.icon-link-list__item {\r\n  height: var(--icon-link-size);\r\n  width: var(--icon-link-size);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
